<template>
  <div class="approve-challenge-container">
    <b-row v-if="userIsAParent && checklist && checklist.length > 0" class="m-0 bg-light">
      <b-col cols="8" class="p-0 pl-2">
        <span class="font-weight-bold text-main2">
          {{ name_time }}
        </span>
      </b-col>
      <b-col cols="2" class="p-0 text-center">
        <small class="text-muted"> Yes </small>
      </b-col>
      <b-col cols="2" class="p-0 text-center">
        <small class="text-muted"> No </small>
      </b-col>
    </b-row>
    <div id="todolist">
      <ul class="list-group mt-2">
        <li
          v-for="item in filteredChecklist()"
          :class="checkColor(item)"
          :key="item.criterionId"
          class="border-0 list-group-item"
          @click="checkController(item)"
        >
          <b-row class="m-0 w-100 " :class="challengeFrequencyClass(item)">
            <div
              v-if="!userIsAParent && challengeHasValidFrequency(item)"
              class="one-time-flag px-3"
            >
              Bonus
            </div>
            <div
              v-if="!userIsAParent && challengeHasValidFrequency(item)"
              class="one-time-flag one-time-flag--date px-1 d-flex"
            >
              <label class="d-none d-md-flex m-0 pr-1">
                <span v-if="item.frequencyId == 'bonus_date'" class="pr-1">
                  Only
                </span>
                Available
              </label>
              Today
            </div>
            <b-col class="p-0" align-self="center" :class="[userIsAParent ? 'col-8' : 'col-11']">
              <div class="d-flex align-items-center">
                <section
                  class="align-items-center justify-content-center image-container-size ml-2 ml-md-0 text-center"
                >
                  <b-img
                    v-if="item.image"
                    fluid
                    :src="item.image"
                    class="h-100 w-100 object-fit-cover rounded"
                  ></b-img>
                  <span v-else class="material-icons text-warning font-big" style="top: 30%;"
                    >emoji_events</span
                  >
                </section>
                <b-col class="d-flex flex-column justify-content-center py-2">
                  <section class="label">
                    <span class="d-block text-break">
                      {{ item.text }}
                    </span>
                  </section>
                  <section
                    class="d-flex flex-column flex-md-row align-items-start align-items-md-center"
                  >
                    <div class="d-flex align-items-center">
                      <b-img
                        fluid
                        :src="require(`@/assets/star.png`)"
                        class="icon-star-small h-auto"
                      ></b-img>
                      <span class=" ml-1">
                        {{ item.coin_value }}
                      </span>
                    </div>
                    <div class="d-flex brands-container ml-0 ml-md-2">
                      <div class="align-items-center" v-if="item.categoryText">
                        <p
                          :style="`background-color:${item.categoryColor};`"
                          class="category-challenge-brand text-white px-2 py-1 small "
                        >
                          {{ item.categoryText }}
                        </p>
                      </div>
                      <div
                        class="align-items-center"
                        v-if="
                          (userIsAParent && item.frequencyValue) ||
                            (!userIsAParent && challengeHasValidFrequency(item))
                        "
                      >
                        <p
                          :style="`background-color:#e9ecef;`"
                          class="category-challenge-brand px-2 py-1 small "
                        >
                          {{ item.frequencyValue }}
                          <span
                            v-if="challengeHasValidFrequency(item)"
                            class="material-icons military_tech text-warning align-middle"
                            >military_tech</span
                          >
                        </p>
                      </div>
                    </div>
                  </section>
                </b-col>
              </div>
            </b-col>
            <!--  Check if parent -->
            <b-col cols="2" class="p-0 text-center " align-self="center" v-if="userIsAParent">
              <section class="check">
                <input
                  type="checkbox"
                  class="d-none"
                  @change="uncheckedWasted(item.criterionId)"
                  v-model="arrayApprovedItems"
                  :value="item.criterionId"
                  :id="`${item.criterionId}check-no`"
                  :disabled="(item.qualifiedParent && item.approvedParent) || !editable"
                />
                <label :for="`${item.criterionId}check-no`"></label>
              </section>
            </b-col>
            <b-col cols="2" class="p-0 text-center" align-self="center" v-if="userIsAParent">
              <section class="no-check">
                <input
                  type="checkbox"
                  class="d-none"
                  @change="uncheckedApproved(item.criterionId)"
                  v-model="arrayWastedItems"
                  :value="item.criterionId"
                  :id="`${item.criterionId}check-yes`"
                  :disabled="(item.qualifiedParent && item.approvedParent) || !editable"
                />
                <label :for="`${item.criterionId}check-yes`"></label>
              </section>
            </b-col>
            <!--  /Check if parent -->
            <!--  Check if child -->
            <b-col
              cols="1"
              class="p-0 text-center pe-none"
              align-self="center"
              v-if="showInputChild()"
            >
              <section class="check-child">
                <input
                  v-if="userIsAParent || !originalApprovedChild.includes(item.criterionId)"
                  type="checkbox"
                  class="d-none"
                  v-model="arrayApprovedItemsChild"
                  :value="item.criterionId"
                  :id="`${item.criterionId}check-child`"
                  :disabled="true"
                />
                <label
                  v-if="
                    !item.qualifiedParent &&
                      (userIsAParent || !originalApprovedChild.includes(item.criterionId))
                  "
                  :for="`${item.criterionId}check-child`"
                ></label>
                <span v-else-if="item.approvedParent" class="material-icons" style="color: #70A839"
                  >check_box</span
                >
                <span
                  v-else-if="originalApprovedChild.includes(item.criterionId)"
                  class="material-icons"
                  style="color: #a7e168"
                  >check_box</span
                >
                <span v-else-if="!item.approvedParent" class="material-icons" style="color: #D25B57"
                  >indeterminate_check_box</span
                >
              </section>
            </b-col>
            <!--  /Check if child -->
          </b-row>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
function ArrayEquals(array1, array2) {
  return JSON.stringify(array1) === JSON.stringify(array2);
}
export default {
  props: {
    child: String,
    date: String,
    time_day: Number,
    name_time: String,
    userIsAParent: Boolean,
    filterByCategory: Array,
    editable: { type: Boolean, default: true },
    checkAll: String,
    id: Number,
  },
  data() {
    return {
      arrayApprovedItemsChild: [],
      originalApprovedChild: [],
      arrayWastedItems: [],
      arrayApprovedItems: [],
      originalApproved: [],
      originalWasted: [],
      buttonActive: false,
      isAllChallenges: true,
    };
  },
  computed: {
    ...mapGetters('user', ['getUserId']),
    ...mapGetters('challenge', ['getCriterionValues', 'getCriterionToday']),
    ...mapGetters('parent', ['getListChildrenSelectFormat', 'getChildChallengeOrder']),
    activeSaveButton() {
      if (this.userIsAParent) {
        return (
          !ArrayEquals(this.arrayWastedItems, this.originalWasted) ||
          !ArrayEquals(this.arrayApprovedItems, this.originalApproved)
        );
      } else {
        return !ArrayEquals(this.originalApprovedChild, this.arrayApprovedItemsChild);
      }
    },
    checklist() {
      let criterion = [];
      if (this.date && this.userIsAParent) {
        this.getCriterionValues(this.child)[this.date].forEach((element) => {
          if (element.time_day == this.id) {
            element.criterion.forEach((item) => {
              const frequencyTime = this.$parent.findFrequencyTime(item.challenge_frequency);
              criterion.push({
                id: item.id,
                approvedChild: item.child_approved,
                approvedParent: item.parent_approved,
                qualifiedParent: item.parent_qualified,
                categoryColor: item.category ? item.category.color : null,
                coin_value: item.coin_value,
                text: item.text,
                categoryText: item.category ? item.category.name : null,
                categoryId: item.category ? item.category.id : 0,
                frequencyId: item.challenge_frequency,
                frequencyValue: frequencyTime ? frequencyTime.text : '',
                criterionId: `${item.challenge_criterion}-${item.id}`,
                image: item && item.image ? item.image : null,
              });
            });
          }
        });
      }
      if (this.date && !this.userIsAParent) {
        this.getCriterionToday.forEach((element) => {
          if (element.time_day == this.id) {
            element.criterion.forEach((item) => {
              const frequencyTime = this.$parent.findFrequencyTime(item.challenge_frequency);
              criterion.push({
                id: item.id,
                approvedChild: item.child_approved,
                approvedParent: item.parent_approved,
                qualifiedParent: item.parent_qualified,
                categoryColor: item.category ? item.category.color : null,
                coin_value: item.coin_value,
                text: item.text,
                categoryText: item.category ? item.category.name : null,
                categoryId: item.category ? item.category.id : 0,
                frequencyId: item.challenge_frequency,
                frequencyValue: frequencyTime ? frequencyTime.text : '',
                criterionId: `${item.challenge_criterion}-${item.id}`,
                image: item && item.image ? item.image : null,
              });
            });
          }
        });
      }
      return criterion;
    },
  },
  methods: {
    ...mapActions('challenge', [
      'setParentCheckValues',
      'FetchChildCriterionValuesByDate',
      'setChildCheckValues',
      'FetchChildCriterionToday',
    ]),
    validateToToggleArray(item) {
      if (!this.userIsAParent && !item.approvedParent && !item.qualifiedParent)
        this.toggleArrayItem(item);
    },
    toggleArrayItem(item) {
      const storeValue = [...this.arrayApprovedItemsChild];
      let i = storeValue.indexOf(item.criterionId);
      if (i === -1) {
        storeValue.push(item.criterionId);
      } else {
        storeValue.splice(i, 1);
      }
      item.approvedChild = !item.approvedChild;
      this.arrayApprovedItemsChild = [...storeValue];
    },
    findFrequencyTime(frequencyId) {
      return this.criterionTimeFrequencyChoices.find((time) => time.id == frequencyId);
    },
    showInputChild() {
      //{{item.qualifiedParent}} - {{item.approvedChild}}
      if (!this.userIsAParent) {
        return true;
      }
      return false;
    },
    uncheckedApproved(id) {
      if (this.arrayApprovedItems.includes(id)) {
        var index = this.arrayApprovedItems.indexOf(id);
        if (index > -1) {
          this.arrayApprovedItems.splice(index, 1);
        }
      }
    },
    uncheckedWasted(id) {
      if (this.arrayWastedItems.includes(id)) {
        var index = this.arrayWastedItems.indexOf(id);
        if (index > -1) {
          this.arrayWastedItems.splice(index, 1);
        }
      }
    },
    calculeApprove() {
      if (this.userIsAParent) {
        this.arrayApprovedItems = [];
        this.arrayWastedItems = [];
        this.originalApproved = [];
        this.originalWasted = [];
        this.checklist.forEach((element) => {
          if (element.qualifiedParent) {
            if (element.approvedParent) {
              this.arrayApprovedItems.push(element.criterionId);
              this.originalApproved.push(element.criterionId);
            } else {
              this.arrayWastedItems.push(element.criterionId);
              this.originalWasted.push(element.criterionId);
            }
          }
        });
        this.originalApproved = this.arrayApprovedItems;
        this.originalWasted = this.arrayWastedItems;
      } else {
        this.arrayApprovedItemsChild = [];
        this.originalApprovedChild = [];
        this.checklist.forEach((element) => {
          if (element.approvedChild) {
            this.arrayApprovedItemsChild.push(element.criterionId);
          }
        });
        this.originalApprovedChild = this.arrayApprovedItemsChild;
      }
    },
    generateDataToSend() {
      const toSend = [];
      if (this.userIsAParent) {
        this.arrayApprovedItems
          .filter((a) => !this.originalApproved.includes(a))
          .forEach((element) => {
            toSend.push({ id: element.split('-')[0], value: true });
          });
        this.arrayWastedItems
          .filter((a) => !this.originalWasted.includes(a))
          .forEach((element) => {
            toSend.push({ id: element.split('-')[0], value: false });
          });
      } else {
        this.arrayApprovedItemsChild
          .filter((a) => !this.originalApprovedChild.includes(a))
          .forEach((element) => {
            toSend.push({ id: element.split('-')[0], value: true });
          });
      }
      return toSend;
    },
    reset() {
      this.originalWasted = this.arrayWastedItems;
      this.originalApproved = this.arrayApprovedItems;
    },
    setAllChecked() {
      this.arrayApprovedItems = []; //EMPTY APPROVE CHALLENGES
      this.checklist.forEach((item) => {
        this.arrayApprovedItems.push(item.criterionId);
        this.uncheckedWasted(item.criterionId);
      });
    },
    isCheckedAll() {
      this.isAllChallenges = true;
      if (this.userIsAParent) {
        this.checklist.forEach((element) => {
          if (element.qualifiedParent) {
            if (!element.approvedParent) {
              this.isAllChallenges = false;
            }
          } else {
            this.isAllChallenges = false;
          }
        });
      }
    },
    getChallengeCheckedValuesFunction(dataToSent) {
      const toSend = this.generateDataToSend();
      if (dataToSent.find((d) => d.timeId == this.time_day)) {
        dataToSent = [
          ...dataToSent.filter((d) => d.timeId == this.time_day),
          { timeId: this.time_day, date: this.date, toSend: toSend },
        ];
      } else {
        dataToSent.push({
          timeId: this.time_day,
          date: this.date,
          toSend: toSend,
        });
      }
      return toSend;
    },
    checkColor(item) {
      return (
        (item.approvedChild && !item.qualifiedParent
          ? 'list-groud-item-checked'
          : item.qualifiedParent && item.approvedParent
          ? 'list-groud-item-approved'
          : item.qualifiedParent && !item.approvedParent
          ? 'list-groud-item-rejected'
          : 'list-group-item-iddle') +
        (!this.userIsAParent
          ? ' list-group-item-pointer list-group-item-child '
          : ' list-group-item-parent ') +
        (!this.userIsAParent && !(item.approvedParent || item.qualifiedParent || item.approvedChild)
          ? ' darker-hover '
          : '')
      );
    },
    filteredChecklist() {
      return this.checklist.filter((check) =>
        this.filterByCategory && this.filterByCategory.length
          ? this.filterByCategory.includes(check.categoryId)
          : true,
      );
    },
    checkController(item) {
      this.userIsAParent || !this.originalApprovedChild.includes(item.criterionId)
        ? this.validateToToggleArray(item)
        : null;
    },
    challengeFrequencyClass(item) {
      let classString = '';
      if (!this.userIsAParent) {
        classString = 'pr-2 rounded';
      } else if (item.frequencyId == 'bonus_date' || item.frequencyId == 'bonus_one_time') {
        classString = 'child-challenge-card-one-time';
      }
      return classString;
    },
    challengeHasValidFrequency(item) {
      const validFrequencyIds = ['bonus_date', 'bonus_one_time'];
      return validFrequencyIds.includes(item.frequencyId);
    },
  },
  watch: {
    checklist: function() {
      this.calculeApprove();
    },
    checkAll: function() {
      this.setAllChecked();
    },
    activeSaveButton: function(val) {
      this.$parent.activeSaveButton(val, this.id);
    },
  },
  mounted() {
    this.calculeApprove();
    this.isCheckedAll();
    this.$root.$off('getChallengeCheckedValues-' + this.time_day);
    this.$root.$on('getChallengeCheckedValues-' + this.time_day, (dataToSent) => {
      return this.getChallengeCheckedValuesFunction(dataToSent);
    });
  },
};
</script>
<style scoped lang="scss">
.approve-challenge-container {
  .object-fit-cover {
    object-fit: cover;
  }
  .image-container-size {
    min-width: 80px;
    width: 80px;
    max-width: 80px;
    min-height: 80px;
    height: 80px;
    max-height: 80px;
  }
  .list-group-item {
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.2em;
    width: 100%;
    border-radius: 5px;
  }
  .list-group-item-parent {
    padding: 0em;
  }
  .list-group-item-child {
    padding: 0em;
  }
  .military_tech {
    font-size: 21px !important;
  }
  .child-challenge-card-one-time {
    border: #ec1b4b 2px solid !important;
  }
  .one-time-flag {
    position: absolute;
    bottom: 100%;
    left: 0;
    background-color: #ec1b4b;
    font-size: 14px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    color: #fff;
    z-index: 10;
  }
  .one-time-flag--date {
    bottom: 0;
    right: 0;
    left: unset;
    border-top-right-radius: 0px;
  }
}
* {
  position: relative;
}
.small-icon {
  font-size: 0.7em;
}
@keyframes strikeitem {
  to {
    width: calc(100% + 1rem);
  }
}
#todolist {
  margin: 0;
}
#todolist .label {
  position: relative;
  transition: opacity 0.2s linear;
  display: inline-block;
}
#todolist .done .label {
  opacity: 0.6;
}
#todolist .line-through .label {
  text-decoration: line-through;
}
.list-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5em;
}
.list-groud-item-checked {
  background-color: #ebfade !important;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.list-groud-item-rejected {
  background-color: #eabbba !important;
}
.list-groud-item-approved {
  background-color: #c1ea94 !important;
}
.list-group-item-iddle {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.item-info {
  flex-grow: 1;
}
.checkbox {
  border-radius: 6px;
}
/*#todolist .done .label:before {
  content: "";
  position: absolute;
  top: 50%;
  display: block;
  width: 100% !important;
  height: 1px;
  background: #000;
  animation: strikeitem 0.3s ease-out 0s forwards;
}*/
.check label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 24px;
  left: 0;
  position: relative;
  top: 0;
  width: 24px;
  margin: 0;
}
.check label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: '';
  height: 6px;
  left: 6px;
  opacity: 0;
  position: absolute;
  top: 7px;
  transform: rotate(-45deg);
  width: 12px;
}
.check input[type='checkbox'] {
  visibility: hidden;
}
.check input[type='checkbox']:checked + label {
  background-color: var(--color-main);
  border-color: var(--color-main);
}
.check input[type='checkbox']:checked + label:after {
  opacity: 1;
}
.no-check label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 24px;
  left: 0;
  position: relative;
  top: 0;
  width: 24px;
  margin: 0;
}
.no-check label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: '';
  height: 2px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 10px;
  width: 12px;
}
.no-check input[type='checkbox'] {
  visibility: hidden;
}
.no-check input[type='checkbox']:checked + label {
  background-color: var(--aside04);
  border-color: var(--aside04);
}
.no-check input[type='checkbox']:checked + label:after {
  opacity: 1;
}
.check-child label {
  border: 1px solid #ccc;
  border-radius: 15%;
  cursor: pointer;
  height: 24px;
  width: 24px;
  left: 0;
  top: 0;
  margin: 0;
}
.check-child label:after {
  border: 2px solid #a7e168;
  border-top: none;
  border-right: none;
  content: '';
  height: 6px;
  left: 4.5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}
.check-child input[type='checkbox'] {
  border-radius: 20px;
}
.check-child input[type='checkbox'] {
  visibility: hidden;
}
.check-child input[type='checkbox']:checked + label {
  background-color: white;
  border: 2px solid #a7e168;
}
.check-child input[type='checkbox']:checked + label:after {
  opacity: 1;
}
.category-challenge-brand {
  border-radius: 50rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
  text-align: center;
  line-height: 1.5 !important;
}
.custom-container-gap {
  column-gap: 0.5rem;
}
.material-icons {
  cursor: default;
  font-size: 1.7rem;
}
.brands-container {
  flex-wrap: wrap;
  gap: 0.5rem;
}
.pe-none {
  pointer-events: none;
}
</style>
